module.exports = __webpack_public_path__ + "static/img/function3.a4dce7b7.png";